import {Component, Inject,OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, of, Subscription, timer} from 'rxjs';
import {map, mergeMap, switchMap} from 'rxjs/operators';
import {CommandMessageResponse} from '../../models/command-message-response';
import {CommandMessageRequest} from '../../models/command-message-request';
import {CommandDataService} from '../../services/command-data.service';
import {TrainDataService} from '../../../../features/trains/services/train-data.service';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import {Command} from '../../models/command';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {StateService, Transition} from '@uirouter/core';
import {FormValidationService} from '../../../../shared/services/form-validation.service';
import { TableStateService } from '../../../../shared/services/table-state.service';

@Component({
  selector: 'app-diagtool-overview',
  template: require('./diagtool-overview.component.html'),
  styles: [require('./diagtool-overview.component.sass')]
})
export class DiagtoolOverviewComponent implements OnInit, OnDestroy {

  constructor(
      public $state: StateService,
      private trans: Transition,
      private commandDataService: CommandDataService,
      private trainDataService: TrainDataService,
      private translate: TranslateService,
      private router: Router,
      private fb: FormBuilder,
      public formValidatorService: FormValidationService,
      @Inject('ProjectService') private projectService: any,
      public tableState: TableStateService
  ) {

    this.commandForm = this.fb.group({
      trains: [[], [Validators.required]],
      box: [[], [Validators.required]],
      commands: [[], [Validators.required]]
    })
    this.languageChangeSubscription = this.translate.onLangChange.subscribe(() => {
      this.refreshDiagTable();
    })
  }
  commandForm: FormGroup;
  
  history: boolean;
  commandResponses$: Observable<CommandMessageResponse[] | null>;

  projectId: number;
  trainId: string;
 // trainIds$: Observable<number[]>;

  trains$: Observable<string[]>;
  commands$: Observable<Command[]>;
  boxIds$: Observable<number[]>;
  loading$: Observable<boolean>;


  tableConfiguration: any = {
    paginate: true,
    sortableMode: 'multiple',
    defaultPagination: 250,
    itemsPerPageOptions: [50, 100, 250, 500]
  };
  columns: any[];
  languageChangeSubscription: Subscription;

  ngOnInit(): void {
    this.projectId = this.trans.params().projectId ? this.trans.params().projectId : this.projectService.getSelectedProjectId();
    this.trainId = this.trans.params().trainId;
    this.history = this.trans.params().history;
    this.trains$ = this.trainDataService.getTrainslist( this.projectId ).pipe ( map ( trains => trains.filter(train => this.trainId ?  train.relativeId.toString() === this.trainId : true).map ( train => train.name ) ) );
    this.commands$ = this.commandDataService.getCommandlist(this.projectId);
    this.boxIds$ = this.commandDataService.getBoxIdsByProject(this.projectId);
    this.refreshDiagTable()
  }

  refreshDiagTable = () => {
    this.columns = [{
      disableSorting: true,
    }, {
      header: this.translate.instant('I18N_DIAGNOSTICS.PROJECT_ID'),
      field: 'projectId',

    }, {
      header: this.translate.instant('I18N_DIAGNOSTICS.TRAIN'),
      field: 'trainId',
    }, {
      header: this.translate.instant('I18N_DIAGNOSTICS.BOX'),
      field: 'boxId',
    }, {
      header: this.translate.instant('I18N_DIAGNOSTICS.COMMAND'),
      field: 'command',
    }, {
      header: this.translate.instant('I18N_DIAGNOSTICS.STATUS'),
      field: 'status',
    }, {
      header: this.translate.instant('I18N_DIAGNOSTICS.TIMESTAMP'),
      field: 'date',
    }, {
      header: this.translate.instant('I18N_DIAGNOSTICS.UUID'),
      field: 'uuid',
    }]
  }
  
  submitRequest = (history?: boolean) => {
    if (this.commandForm.valid) {
    const request: CommandMessageRequest = {
      projectId: this.projectId,
      trainIds:  this.commandForm.value.trains,
      boxIds: this.commandForm.value.box,
      commands: this.commandForm.value.commands
    };
    if (!history) {
      // LAUNCH PERIODIC POLLING OF RESPONSES
      this.commandResponses$ = this.commandDataService.createRequest(request).pipe(switchMap(responses => {
        const uuids = responses && responses.map(response => response.uuid);
        return uuids ? timer(0, environment.config.diagtool.pollingCommandResponse).pipe(
            mergeMap(() => this.commandDataService.getResponsesByCommand(uuids))) : of(null);
      }));
    } else {
      this.commandResponses$ = this.commandDataService.getCommandsHistory(request);
    }
    if (this.commandForm.value.trains.length === 1) {
      this.commandResponses$ = this.commandResponses$.pipe(map(responses => {
        // tslint:disable-next-line:no-unused-expression
        responses && responses.map(response => response.isExpanded = true);
        return responses;
      }));
    }
    this.loading$ = this.commandResponses$.pipe(map(commandResponses => !!commandResponses));
    this.commandForm.reset();
    }
    else{
      this.formValidatorService.validateAllFormFields(this.commandForm);
    }
  }

  timestampToDatestring(date: number) {
    const timestamp = new Date(date);
    return `${timestamp.toLocaleDateString()} ${timestamp.toLocaleTimeString()}`;
  }

  expandResponse(response: CommandMessageResponse) {
    response.isExpanded = !response.isExpanded;
  }
  showHistory() {
    if (this.projectId && this.trainId) {
      this.$state.go ( 'diagtool-history', {
        projectId: this.projectId,
        trainId: this.trainId
      } );
    } else {
      this.$state.go ( 'diagtool-history', {
        projectId: this.projectId
      } )
    }

  }

  showSubmitNewRequest() {
    this.$state.go ( 'diagtool', {
      projectId: this.projectId
    });
  }


  ngOnDestroy(): void {

  }
}
